var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-33",
    cx: 250,
    cy: 376.66,
    rx: 189.51,
    ry: 99.06,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-33",
    cx: 320.65,
    cy: 400.05,
    rx: 55.41,
    ry: 26.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-33",
    d: "M132.72,420.58c21.55,10.27,56.48,10.27,78,0s21.54-26.92,0-37.19-56.48-10.27-78,0S111.17,410.31,132.72,420.58Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.23,349.47l6.71-3.83s3.22-17.74.81-33c-3.38-21.43-18-28.83-23.28-26.7s-6.55,8.48,3,20.87C97.15,314.13,104.41,329.58,104.23,349.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,341h-.06a.46.46,0,0,1-.41-.53c2.77-20.07-5.3-42.06-14.37-50.92a.48.48,0,0,1,.67-.69c9.24,9,17.46,31.37,14.65,51.74A.48.48,0,0,1,106.66,341Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,360.23c-1.06.61-3.24-.72-4.08-1.28a10.23,10.23,0,0,1-3.37-3.87,9.53,9.53,0,0,1-.84-5.69,22.61,22.61,0,0,1,.72-3c.28-1,.56-2,.85-2.94a7.76,7.76,0,0,0,.43-3c-.26-2-2-3.42-3.67-4.63-1.79-1.34-3.66-3.12-3.65-5.54a8.61,8.61,0,0,1,2.13-5.07c1.16-1.46,2.53-2.76,3.58-4.3a6,6,0,0,0,1.22-3.76,6.17,6.17,0,0,0-.82-2.35,32.75,32.75,0,0,1-2.57-4.72c-.59-1.69-.51-3.8.81-5a5.56,5.56,0,0,1,4.17-1,9.55,9.55,0,0,1,3.87,1.36c3.84,2.14,6,6.69,10.11,8.33a39.55,39.55,0,0,0,4.94,1.21,6.07,6.07,0,0,1,4.07,2.79c1.5,3-1.28,6.67-.23,9.84.93,2.81,3.66,3.89,5.19,6.42a6,6,0,0,1,.72,3.67,17.52,17.52,0,0,1-1.55,6.22,45,45,0,0,1-3.41,5.59C104.17,349.54,85.77,360.14,85.61,360.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.51,354.43h0a.49.49,0,0,1-.46-.5c.79-19-8.16-40-14.67-46.06a.49.49,0,0,1,0-.68.47.47,0,0,1,.67,0c6.64,6.21,15.77,27.53,15,46.8A.48.48,0,0,1,96.51,354.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.66,332a.32.32,0,0,1-.14,0,63.79,63.79,0,0,0-13.79-2.22.49.49,0,0,1-.46-.5.47.47,0,0,1,.5-.46,65.51,65.51,0,0,1,14,2.27.47.47,0,0,1-.14.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.5,358.94l-7.09-4.09s-1.74-15.18-.58-26.93c1.62-16.52,12.29-36.4,25-31.73s-5.84,21.49-10,35.5S414.5,358.94,414.5,358.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.77,357.22h0a.43.43,0,0,0,.41-.44c-1.24-36.71,17-55.17,17.21-55.35a.43.43,0,0,0,0-.61.42.42,0,0,0-.6,0c-.19.18-18.73,18.91-17.47,56A.43.43,0,0,0,410.77,357.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.28,361.87l-5-2.91a55.59,55.59,0,0,1,4.25-23.07c4.44-11,15.47-20.15,21-18.23s5.41,5.85,2.71,10S422.05,341.6,418.28,361.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62,360.76h0a.43.43,0,0,0,.43-.43c-.1-23.2,21.69-38.89,21.91-39a.43.43,0,0,0-.5-.7c-.22.16-22.37,16.1-22.27,39.75A.42.42,0,0,0,415.62,360.76Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.38,156.89s-24.74-12.36-29-26.38c-2.1-6.94-2.93-21.07-1.72-27.6a5.69,5.69,0,0,1,1.83-3c2-2,2.5-4.55,4.3-6.85,1.4-1.8,2-2.29,1.77-2.79a2.62,2.62,0,0,0-3.44-.84,18,18,0,0,0-3.59,2.43,24,24,0,0,1,3.22-7c3.28-5-.25-7.07-4.4-7.12-4.75,0-9.23,3.43-11.74,14.21a87.46,87.46,0,0,0-1.38,14.47c-.05,12.11.21,22.53,1.43,28.59,2.9,14.38,11.3,21.6,18.85,28.77,6.9,6.57,11.48,10,15.32,13.23C313.72,164.67,309.38,156.89,309.38,156.89Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.94,156c-1.47-4.24-11.09-6.75-12.81-9.76-3.38-5.89-6.16-13.71-14.66-9.66,0,0-4.07,9.57-12.67,10a13.4,13.4,0,0,0-1.06,9.2c.55,2.59,6.42,9.13,15.44,12.88,8.15,3.38,5.75,6.6,14.3,9.24C306.34,173.53,318.55,166.32,310.94,156Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.94,156c-1.47-4.24-11.09-6.75-12.81-9.76-3.38-5.89-6.16-13.71-14.66-9.66,0,0-4.07,9.57-12.67,10a13.4,13.4,0,0,0-1.06,9.2c.55,2.59,6.42,9.13,15.44,12.88,8.15,3.38,5.75,6.6,14.3,9.24C306.34,173.53,318.55,166.32,310.94,156Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.47,136.57s-1.24,5.43-5.43,7.84c-5.36,3.07-7.24,2.19-7.24,2.19a18.94,18.94,0,0,1-2.72-6.29s10.77-.7,12.55-9.1A37.17,37.17,0,0,1,283.47,136.57Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.47,136.57s-1.24,5.43-5.43,7.84c-5.36,3.07-7.24,2.19-7.24,2.19a18.94,18.94,0,0,1-2.72-6.29s10.77-.7,12.55-9.1A37.17,37.17,0,0,1,283.47,136.57Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.61,
    y: 379.77,
    width: 10.48,
    height: 17.94,
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.76 387.35 304.28 387.71 303.76 368.72 314.76 368.36 314.76 387.35",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.06,240.33c0,10-1.77,68.22-1.77,68.22.25,2.88,3,8,3.23,18.37.32,15-1,61.82-1,61.82a13.8,13.8,0,0,1-11.67.23s-9.25-61.46-11.12-76.35c-1.64-13-4.42-48.29-4.42-48.29l-5.68,42.41A59.72,59.72,0,0,1,320,323.4c-.49,6.89-4.53,58.07-4.53,58.07s-4.93,3.34-12.1.92c0,0-5.3-69.33-5.42-75.65-.13-7.2,3.49-80.73,3.49-80.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,392.53V391c-1,.44-3.33,9.33-7.49,13.12-3.3,3-7.81,6.5-9,9.86s6.28,5.43,9.37,4.88c3.59-.64,9.81-3.16,11.37-5.5s2.29-5.8,3.56-7.52,4.19-3.63,4.88-5.62c.37-1.09-.07-3.48-.6-5.5-.49-1.85-1-3.89-1.65-3.72v1.15c-.76.84-2.86,1.68-5.24,1.77C344.32,394,340.6,393.7,340.61,392.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.17,384.48c-.54,0-1,.78-2.18,2.08a23.07,23.07,0,0,1-6.17,4.44c-3.92,2-11.55,5-15,6.54-2.15,1-2.05,3.58.18,5.06s7.61,2.55,14.08,1.1c3.52-.78,8.1-4,11-3.86s8.33.13,10.47-1.34,1.29-4.63.68-7.34c-.66-3-1.48-7.57-2.46-7.36v1c-1.26,1.91-7.76,2.69-10.53,1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.77,
    cy: 121.46,
    r: 14.4,
    transform: "translate(6.6 258.86) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.69,139.07,337.74,116a5.39,5.39,0,0,1,4.47,1.58c1.92,2-1.7,14.92-2.13,16.79h0c-.75,3.36-2,8.88-2.68,10.11a5,5,0,0,1-2.87,2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,132.21c.88.53,2.14-1.17,3.23-2.31s4.63-2.69,6.4,1-1.56,8.83-4.35,9.7c-4.82,1.52-5.54-1.57-5.54-1.57l-.35,17.74V157c-3,3.83-10.51,16.71-14.54,16.5S315.2,160,318.66,156v-5.29a30.34,30.34,0,0,1-6.49.33c-3.54-.54-5.77-3.34-6.84-7.17-1.73-6.16-2.38-11.13-.92-23.23,1.61-13.28,17-13.41,25.38-8.17S335,132.21,335,132.21Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28,155.23a12.26,12.26,0,0,1-9.32,5.7l-5.8,11.4-.88-11.76-2.59-7a31.15,31.15,0,0,0-6.12,1.19,18.72,18.72,0,0,0-8.4,7.88c-2.78,4.77-3.78,15.18-3.78,22.78s-1.52,41.41-2.24,69.53c-.46,17.8-3,67.14-3.62,91.64,5.61,10.63,19,12.14,33.94,12.95,13.29.73,30.37-7.37,33.93-12.71.19-14-1.73-44.49-2.67-87.58-1-46.12-2.79-75.77-2.62-76.58,1.33-6.27,3.32-21-1.86-23.64C350.06,157.42,335.28,155.23,335.28,155.23Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28,155.23a12.26,12.26,0,0,1-9.32,5.7l-5.8,11.4-.88-11.76-2.59-7a31.15,31.15,0,0,0-6.12,1.19,18.72,18.72,0,0,0-8.4,7.88c-2.78,4.77-3.78,15.18-3.78,22.78s-1.52,41.41-2.24,69.53c-.46,17.8-3,67.14-3.62,91.64,5.61,10.63,19,12.14,33.94,12.95,13.29.73,30.37-7.37,33.93-12.71.19-14-1.73-44.49-2.67-87.58-1-46.12-2.79-75.77-2.62-76.58,1.33-6.27,3.32-21-1.86-23.64C350.06,157.42,335.28,155.23,335.28,155.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.28,160.57v-4.08a1.27,1.27,0,0,0-.62-1.17V151.4a4.32,4.32,0,0,0-1.37.43,1.59,1.59,0,0,0-.6,1.49v2.05S316,160.57,319.28,160.57Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.28,160.57v-4.08a1.27,1.27,0,0,0-.62-1.17V151.4a4.32,4.32,0,0,0-1.37.43,1.59,1.59,0,0,0-.6,1.49v2.05S316,160.57,319.28,160.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,160.93s0-3.11,0-3.75.25-1.07,2-1.5,6-3.33,6.52-4.82l0-1.53a1.32,1.32,0,0,1,1.25,1.22,40.5,40.5,0,0,1-.43,4.68C333.66,158.67,329.17,161.4,326,160.93Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,160.93s0-3.11,0-3.75.25-1.07,2-1.5,6-3.33,6.52-4.82l0-1.53a1.32,1.32,0,0,1,1.25,1.22,40.5,40.5,0,0,1-.43,4.68C333.66,158.67,329.17,161.4,326,160.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,133.69c.45,0,2.13-2.79,3.23-3.79,1.52-1.38-.44-13.91-.44-13.91a5.92,5.92,0,0,0-1.47-6.33c-2.08-2.3-5.56-2.55-11.51-3.48-1.91-.3-3.72-.14-5.65-.3l-7.73-.66a30.75,30.75,0,0,1-9.43-1.81.93.93,0,0,0-.54-.11c-.32.08-.44.46-.49.79a12.58,12.58,0,0,0,1,6.16c2,5.35,6.35,7.13,11.67,7.77,5.64.69,14.43-.13,15.63-.29,1.64-.23,2,1.36,2.87,5.69C332.82,127.22,333.46,133.66,335,133.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,117l5.33-2.86a2.94,2.94,0,0,0-4-1.34A3.18,3.18,0,0,0,337.73,117Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.67,150.69s7.91-1.59,10.67-3.06a9.11,9.11,0,0,0,3.82-3.78,12.56,12.56,0,0,1-2.17,4.46c-2,2.58-12.32,4.48-12.32,4.48Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,131.26a1.59,1.59,0,1,0,1.58-1.65A1.61,1.61,0,0,0,318.05,131.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,124.55l3.67,1.21a2,2,0,0,0-1.27-2.5A1.88,1.88,0,0,0,319.77,124.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,141.92l-3.62,1.35a1.9,1.9,0,0,0,2.46,1.2A2,2,0,0,0,318,141.92Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,125l3.63-1.43a1.87,1.87,0,0,0-2.47-1.14A2,2,0,0,0,304.63,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,130.94a1.59,1.59,0,1,0,1.58-1.65A1.61,1.61,0,0,0,305.09,130.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.09 130.07 313.57 139.59 308.6 137.9 314.09 130.07",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,62.8l5-10.52h0c.93-2.06,3.66-3.26,7.95-3.11,8.49.29,19.87,5.75,25.41,12.18,2.8,3.26,3.57,6.14,2.56,8.15h0l-5,10.47c-.94,2-3.67,3.24-7.95,3.09-8.48-.3-19.86-5.75-25.4-12.19-2.77-3.21-3.56-6-2.6-8.06h0Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.58,62.8l5-10.52h0c.93-2.06,3.66-3.26,7.95-3.11,8.49.29,19.87,5.75,25.41,12.18,2.8,3.26,3.57,6.14,2.56,8.15h0l-5,10.47c-.94,2-3.67,3.24-7.95,3.09-8.48-.3-19.86-5.75-25.4-12.19-2.77-3.21-3.56-6-2.6-8.06h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "315.71 46.03 334.51 73.51 301.31 76.05 282.52 48.58 315.71 46.03",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.71 46.03 334.51 73.51 301.31 76.05 282.52 48.58 315.71 46.03",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.51 73.51 333.99 74.58 300.8 77.12 301.31 76.05 334.51 73.51",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.51 73.51 333.99 74.58 300.8 77.12 301.31 76.05 334.51 73.51",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.52 48.58 282 49.65 300.8 77.12 301.31 76.05 282.52 48.58",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.52 48.58 282 49.65 300.8 77.12 301.31 76.05 282.52 48.58",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.95 75.58 300.03 78.73 289.42 60.48 300.8 77.12 320.95 75.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,61.69a.66.66,0,0,1-.38-.12c-.17-.13-16.38-12.37-14-34.5a.67.67,0,0,1,.72-.58.65.65,0,0,1,.57.72A38.12,38.12,0,0,0,308.9,60.52a.64.64,0,0,1,.13.91A.64.64,0,0,1,308.51,61.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.18,25.4a2.25,2.25,0,0,1,1.83.22l2.55-8.35c.2-1.61-4.57-2.2-4.77-.59Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.7,20.51l.27-4.72-.3.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,16.07,296,23.6l1.86-7.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.48,15.79l-.3,0-.59,6.06Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.34,26.29a1.22,1.22,0,0,1-1.42,1A1.23,1.23,0,0,1,293.77,26a1.31,1.31,0,0,1,2.57.32Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.78,25.91a1.06,1.06,0,0,1,1.49-.26.89.89,0,0,1-.17,1.61,1.18,1.18,0,0,0,1.24-1A1.21,1.21,0,0,0,295.19,25,1.23,1.23,0,0,0,293.78,25.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.13,143.14c-1.58,3.56-12,21.85-15.91,28.05-4.1,6.48-4.21,6.8-7.2,11.51-11.63-5.63-4.6-24.36-4.6-24.36s15.14-22,15.6-22.91a11.17,11.17,0,0,0,1-2.76c.34-1.8,2.26-23.83,1.5-30.55A5,5,0,0,0,366.91,99c-2.39-2.15-3.18-4.06-4.83-6.53-1.3-1.93-2.58-2.58-2.28-3.07a2.65,2.65,0,0,1,3.55-.6,18.62,18.62,0,0,1,3.45,2.72,24.52,24.52,0,0,0-2.74-7.38c-3-5.27-2.64-8.13,5-6.88,4.78.78,9.28,4.73,11,15.85.51,3.2.43,8,.48,12.1.09,9.36-.26,24.14-.74,30.59C379.57,139.12,379.7,139.59,378.13,143.14Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,91.68a13.29,13.29,0,0,0-5,11.34s2.13-4.39,4-4.73c0,0,.86,4.84,2.28,7.15,0,0-.33-8.1,2.52-11.58Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,91.68a13.29,13.29,0,0,0-5,11.34s2.13-4.39,4-4.73c0,0,.86,4.84,2.28,7.15,0,0-.33-8.1,2.52-11.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,66.25l0,.07A6.8,6.8,0,0,0,350.5,68c-4,3.27-6.54,10-5.71,15.12.38,2.34,1.44,3.87,2.83,4.58v0c2.3,1.51,23.12,5.47,23.12,5.47L377,76.37S357.21,65.64,354.4,66.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,77.08a14.83,14.83,0,0,0-4.73,12.54c.37,2.27,1.54,3.24,3,3.62,1.25.33,4.95,1.94,6.91,2.71,3.31-2.7,5.5-13.28,4.81-17.5A31.14,31.14,0,0,1,377,76.34,4,4,0,0,0,372.46,77.08Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,78.72a2.7,2.7,0,0,0-.4-.14l-.05,0h0a3.47,3.47,0,0,0-3.71.86A14.78,14.78,0,0,0,374.91,92c.35,2.16,1.38,3.52,2.74,4h0s14.84,10.89,17.29,11.41,9.42-24.18,9.42-24.18C402.61,81.67,386.44,79.63,383.81,78.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.56,
    cy: 95.24,
    rx: 12.98,
    ry: 7.5,
    transform: "translate(169.32 435.4) rotate(-69.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,140.32s2.44,4.6,7.09,5.92,6.55.29,6.55.29,1.42-2.76,2.64-5.62c0,0-9.46.78-12.94-5.66C366.11,135.25,364.36,138,362.77,140.32Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,140.32s2.44,4.6,7.09,5.92,6.55.29,6.55.29,1.42-2.76,2.64-5.62c0,0-9.46.78-12.94-5.66C366.11,135.25,364.36,138,362.77,140.32Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,157.12c.95-1.68,5.48-2.57,6.64-5.84,2.26-6.41,3.06-13.41,12.15-11,0,0,5.1,7.31,13.64,6.21a14.35,14.35,0,0,1,3.11,9.31c-.08,2.65-3.93,9.88-12.12,15.18-7.42,4.8-4.47,7.54-12.41,11.68C347.46,179.61,338.34,168.65,344,157.12Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,157.12c.95-1.68,5.48-2.57,6.64-5.84,2.26-6.41,3.06-13.41,12.15-11,0,0,5.1,7.31,13.64,6.21a14.35,14.35,0,0,1,3.11,9.31c-.08,2.65-3.93,9.88-12.12,15.18-7.42,4.8-4.47,7.54-12.41,11.68C347.46,179.61,338.34,168.65,344,157.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.6,93.14c-.53-.17-1.08-1.78-3-3.33S360.2,88,359.45,89s0,.83,1.64,2.64,2.33,4,4.81,6.34",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.55,382.75a38.05,38.05,0,0,1-.85,4.54c-.55,2-1,5.41-.66,7.07s4.27,4,6.89,4.35,6.39,2.79,8.5,4.64c2.59,2.26,8.09,4.55,11.74,4.13s7.51-1.61,8.68-4.09c.73-1.55-2.44-3.15-10.43-8s-11-7.51-13.45-12.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.45,385a55.94,55.94,0,0,0-.85,9c-.1,5.44-1.1,7.37-1.23,11.84-.16,5.09.72,7,2.79,9.87s7.51,5.47,9.8.62,2-8,1.27-13c-.76-5.17-.86-8-1.3-12-.39-3.48-.85-6.12-.85-6.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,342.09c.27,12,6,42.9,6,42.9a8.92,8.92,0,0,0,9.63.18s2.19-27.93,3.95-40.85c.09-.64.17-1.26.25-1.87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,348.85c.48,13.38,1.12,33.9,1.12,33.9a9.41,9.41,0,0,0,10.42.08s2.2-19.46,4.49-34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.45,385s0,12.75,1.12,17,7.84,4.05,8.26.15.25-17,.25-17l-9.62-.53",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,396.14c-6.17-4.37-12.54-8.87-14.65-13.31l-8.64-.06-1.78,0c.58,3.11,5.84,5.77,9,8.53C185.81,393.28,192.74,399.85,199.62,396.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,103.42a18.47,18.47,0,0,0-12.58,5.08l-1.19-4.23a3.08,3.08,0,0,0-1.05,4.79l-3.17-.92a3,3,0,0,0,1.84,3.54,2.41,2.41,0,0,0,.7.07A24.51,24.51,0,0,0,151.28,126v1.22h0v46.26h40.91V127.25h0v-4.06C190.5,112,181.58,103.42,171.2,103.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,115.09c2.52,1.48,5.63,7.81,5.32,21.08-.26,11.25-3.91,14-5.74,14.83s-5.36.31-8.79-.26v6.75s7.27,11.29,7,14.38-6.84,3.83-11.28.8S161.66,158,161.66,158l.08-15.52s-2,2-5.45-1c-2.82-2.47-3.78-6.64-1.57-8.88a4.92,4.92,0,0,1,7.83,1.56c.95,2,3.12,2.08,3.11-.25,0-6.4,3.73-7.72,4.3-17.57C177.1,114,180.64,114.88,185.89,115.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,107.11c9.85,1,12.4,13,11.32,21.1h0c-9.3,0-18-3-23.88-10.46l-.65-2.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,132.92a1.41,1.41,0,1,1-1.48-1.4A1.44,1.44,0,0,1,178.89,132.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,142.88l3.29,1.05a1.7,1.7,0,0,1-2.14,1.18A1.81,1.81,0,0,1,179,142.88Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9,128.16l-2.86-2a1.69,1.69,0,0,1,2.38-.49A1.84,1.84,0,0,1,191.9,128.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,129.15l3.06-1.66a1.67,1.67,0,0,0-2.31-.74A1.83,1.83,0,0,0,172.55,129.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59,132.32a1.42,1.42,0,1,1-1.49-1.4A1.45,1.45,0,0,1,189.59,132.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 131.51 183.14 140.03 187.62 138.64 182.92 131.51",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,133.17a4.92,4.92,0,0,1,4.76-4.57h.23a4.93,4.93,0,0,1,5.21,4,4.77,4.77,0,0,1-4.46,5.44l-.74,0A4.77,4.77,0,0,1,171.58,133.17Zm4.55-3.76a4,4,0,0,0-3.63,5,4.07,4.07,0,0,0,4.19,2.95l.44,0a4,4,0,0,0,3.85-3.36,4,4,0,0,0-4.12-4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,132.44a5,5,0,0,1,4.76-4.58h.23a4.93,4.93,0,0,1,5.21,4.06,4.76,4.76,0,0,1-4.46,5.43l-.73,0A4.76,4.76,0,0,1,185.23,132.44Zm4.55-3.76a4,4,0,0,0-3.62,4.95,4,4,0,0,0,4.18,2.94l.44,0a4.06,4.06,0,0,0,3.86-3.37,4,4,0,0,0-4.12-4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.28,131.65a3.49,3.49,0,0,1,2-.9,2.56,2.56,0,0,1,2.23.72l.62-.52a3.28,3.28,0,0,0-2.93-1,4.26,4.26,0,0,0-2.5,1.09C180.51,131.27,181.11,131.8,181.28,131.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,133.91l9.56-.49,0-.81-10,.53A5.4,5.4,0,0,1,162.45,133.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,150.74c-3.62-.47-11.06-2.61-12.22-5.55a7.67,7.67,0,0,0,2.61,3.75c2.23,1.9,9.61,4.05,9.61,4.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,186.84s5.9,13.86,10.52,27.75c2.5,7.49,6.12,18.52,6,25.16a5.68,5.68,0,0,1-1.31,3.21c-1.63,2.29-1.7,4.91-3.09,7.47-1.08,2-1.61,2.6-1.28,3a2.61,2.61,0,0,0,3.53.26,17.91,17.91,0,0,0,3.13-3,24.05,24.05,0,0,1-2,7.48c-2.4,5.45,1.43,6.92,5.53,6.28,4.69-.74,7-4.69,7.64-15.74a68.66,68.66,0,0,0-.81-12.79c-2-11.95-4.46-22.35-6-28.52A223.26,223.26,0,0,0,195.54,168c-3.35-7.45-7.36-10.69-14.51-10.48C173.26,173.63,187.21,186.84,187.21,186.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,157.54a14.19,14.19,0,0,1,7.7,0c4.11,1.18,8,3.25,10.12,9.07,1.7,4.6,3.24,9.78,6.06,13.42s6.31,11.32,1.3,16.83c0,0-8.85,1.31-12.58,6.19,0,0-9-.82-10.71-9.56C181.53,186.38,181,157.54,181,157.54Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,157.54a14.19,14.19,0,0,1,7.7,0c4.11,1.18,8,3.25,10.12,9.07,1.7,4.6,3.24,9.78,6.06,13.42s6.31,11.32,1.3,16.83c0,0-8.85,1.31-12.58,6.19,0,0-9-.82-10.71-9.56C181.53,186.38,181,157.54,181,157.54Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.63,203s1.14-2.64,5.39-4.56a15.66,15.66,0,0,1,7.19-1.63s1.67,4,1.74,6.19a33.63,33.63,0,0,0-6,2,28.49,28.49,0,0,0-6.15,4.1S193.77,204.7,193.63,203Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.63,203s1.14-2.64,5.39-4.56a15.66,15.66,0,0,1,7.19-1.63s1.67,4,1.74,6.19a33.63,33.63,0,0,0-6,2,28.49,28.49,0,0,0-6.15,4.1S193.77,204.7,193.63,203Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,157.6a10,10,0,0,0,8.52,5.77l5.79,10,.1-10.62s3.07-1.46.67-5.19H181s7.78,5,11.5,10.82,3.25,10.47,2.49,17c-.5,4.32-3.34,18.41-3.34,18.41s5.63,25.57,4.66,50.89c-.67,17.17,1,76.87.11,98.11-4.44,15.08-28.13,21.39-43.08,20.85-12.36-.44-20.4-5.34-25.7-14.53-.19-14,4.08-82.93,7.66-103.15s6.29-31.68,8.14-35.76a86.26,86.26,0,0,1,9.05-15.27c-.15-4.28-1.24-9.2-4.61-16a39.25,39.25,0,0,1-2.06-4.67c-1.33-6.27-4.18-21.48,1-24.15C150,158.45,161.66,157.6,161.66,157.6Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,157.6a10,10,0,0,0,8.52,5.77l5.79,10,.1-10.62s3.07-1.46.67-5.19H181s7.78,5,11.5,10.82,3.25,10.47,2.49,17c-.5,4.32-3.34,18.41-3.34,18.41s5.63,25.57,4.66,50.89c-.67,17.17,1,76.87.11,98.11-4.44,15.08-28.13,21.39-43.08,20.85-12.36-.44-20.4-5.34-25.7-14.53-.19-14,4.08-82.93,7.66-103.15s6.29-31.68,8.14-35.76a86.26,86.26,0,0,1,9.05-15.27c-.15-4.28-1.24-9.2-4.61-16a39.25,39.25,0,0,1-2.06-4.67c-1.33-6.27-4.18-21.48,1-24.15C150,158.45,161.66,157.6,161.66,157.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,163.37s-.05-3.12,0-3.76-.26-1.06-2-1.49-6.05-3.34-6.54-4.83V151.8a1.29,1.29,0,0,0-1.26,1.19,40.73,40.73,0,0,0,.43,4.68C162.47,161.11,167,163.84,170.18,163.37Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,163.37s-.05-3.12,0-3.76-.26-1.06-2-1.49-6.05-3.34-6.54-4.83V151.8a1.29,1.29,0,0,0-1.26,1.19,40.73,40.73,0,0,0,.43,4.68C162.47,161.11,167,163.84,170.18,163.37Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,162.73v-4.08a1.25,1.25,0,0,1,.61-1.16v-3.93a4.38,4.38,0,0,1,1.37.44,1.6,1.6,0,0,1,.61,1.49v2S179.35,162.73,176.07,162.73Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,162.73v-4.08a1.25,1.25,0,0,1,.61-1.16v-3.93a4.38,4.38,0,0,1,1.37.44,1.6,1.6,0,0,1,.61,1.49v2S179.35,162.73,176.07,162.73Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,118.11a1.78,1.78,0,0,0,1.59,0L150,126.5c0,1.59-4.11,1.59-4.11,0Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,122.9l-.26,4.61-.25-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,127.54l-.55-7.48.81,7.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,127.69h-.26l.13-5.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91,118a.5.5,0,0,0,.5-.51V105.6a1.54,1.54,0,0,1,.77-1.32l-.5-.88a2.53,2.53,0,0,0-1.28,2.2v11.9A.51.51,0,0,0,147.91,118Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,117.5a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,149,117.5Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,117.57A.87.87,0,0,0,148,118a.92.92,0,0,0,0-1.58,1.1,1.1,0,0,1,1,1.09,1.11,1.11,0,0,1-2.22.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,116.26V104.6h0c0-2.26,1.9-4.52,5.83-6.25,7.78-3.4,20.39-3.4,28.17,0,3.94,1.73,5.88,4,5.84,6.25h0v11.62c0,2.25-1.91,4.5-5.84,6.22-7.78,3.4-20.39,3.4-28.17,0-3.88-1.7-5.82-3.93-5.83-6.15h0Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.45,116.26V104.6h0c0-2.26,1.9-4.52,5.83-6.25,7.78-3.4,20.39-3.4,28.17,0,3.94,1.73,5.88,4,5.84,6.25h0v11.62c0,2.25-1.91,4.5-5.84,6.22-7.78,3.4-20.39,3.4-28.17,0-3.88-1.7-5.82-3.93-5.83-6.15h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "172.37 88.12 201.2 104.77 172.37 121.41 143.54 104.77 172.37 88.12",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.37 88.12 201.2 104.77 172.37 121.41 143.54 104.77 172.37 88.12",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.91,105.56a.6.6,0,0,0-.48-.7l-22-4.08-1.6.93L172.22,106h.11A.59.59,0,0,0,172.91,105.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.2 104.77 201.2 105.95 172.37 122.6 172.37 121.41 201.2 104.77",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.2 104.77 201.2 105.95 172.37 122.6 172.37 121.41 201.2 104.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.54 104.77 143.54 105.95 172.37 122.6 172.37 121.41 143.54 104.77",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.54 104.77 143.54 105.95 172.37 122.6 172.37 121.41 143.54 104.77",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 112.49 172.37 124.38 154.91 112.52 172.37 122.6 189.87 112.49",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,102.52a2.56,2.56,0,0,1,3-2.51l22,4.06a.6.6,0,0,1,.48.7.59.59,0,0,1-.58.49h-.11l-22-4.06a1.32,1.32,0,0,0-1.11.29,1.45,1.45,0,0,0-.18.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,144.17c1.58,3.56,12,21.85,15.91,28.05,4.1,6.47,5.06,7.32,8.05,12,11.63-5.62,3.75-24.87,3.75-24.87s-15.14-22-15.61-22.91a11.94,11.94,0,0,1-1-2.77c-.33-1.79-2.25-23.82-1.49-30.55a4.88,4.88,0,0,1,1.63-3.07c2.39-2.15,3.18-4.06,4.83-6.53,1.3-1.93,2.58-2.58,2.28-3.07a2.65,2.65,0,0,0-3.55-.6,18.62,18.62,0,0,0-3.45,2.72A24.52,24.52,0,0,1,136,85.21c3-5.27,2.64-8.13-5-6.88-4.77.78-9.27,4.72-11,15.85-.51,3.2-.43,8-.47,12.1-.1,9.36.26,24.14.73,30.59C120.53,140.15,120.4,140.61,122,144.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,92.71a13.29,13.29,0,0,1,5,11.34s-2.13-4.39-4-4.74c0,0-.87,4.84-2.28,7.15,0,0,.33-8.09-2.52-11.58Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,92.71a13.29,13.29,0,0,1,5,11.34s-2.13-4.39-4-4.74c0,0-.87,4.84-2.28,7.15,0,0,.33-8.09-2.52-11.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7,67.28l0,.07A6.83,6.83,0,0,1,149.6,69c4,3.26,6.54,10,5.71,15.12-.39,2.34-1.44,3.87-2.83,4.57v0c-2.31,1.51-23.12,5.47-23.12,5.47L123.08,77.4S142.89,66.67,145.7,67.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63,78.11a14.81,14.81,0,0,1,4.74,12.54c-.38,2.27-1.54,3.24-3,3.62-1.25.33-5,1.93-6.91,2.71-3.31-2.71-5.51-13.28-4.81-17.5a31.14,31.14,0,0,0,5.44-2.11A3.94,3.94,0,0,1,127.63,78.11Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.29,79.74a2.67,2.67,0,0,1,.4-.13l0,0h0a3.51,3.51,0,0,1,3.72.87A14.81,14.81,0,0,1,125.19,93c-.35,2.16-1.38,3.52-2.74,4h0s-14.84,10.88-17.29,11.41-9.42-24.19-9.42-24.19C97.49,82.69,113.66,80.66,116.29,79.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 96.26,
    rx: 7.5,
    ry: 12.98,
    transform: "translate(-27.52 41.72) rotate(-20.69)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,141.35s-2.44,4.6-7.09,5.92-6.55.28-6.55.28-1.42-2.75-2.64-5.61c0,0,9.45.77,12.94-5.66C134,136.28,135.74,139,137.33,141.35Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,141.35s-2.44,4.6-7.09,5.92-6.55.28-6.55.28-1.42-2.75-2.64-5.61c0,0,9.45.77,12.94-5.66C134,136.28,135.74,139,137.33,141.35Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,158.15c-1-1.68-5.48-2.57-6.64-5.84-2.26-6.41-3.06-13.41-12.15-11,0,0-5.1,7.31-13.64,6.2a14.39,14.39,0,0,0-3.11,9.32c.08,2.65,3.93,9.88,12.12,15.18,7.41,4.8,5.33,8,13.26,12.19C153.5,181.15,161.75,169.68,156.12,158.15Z",
    style: {
      fill: "#58ACE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,158.15c-1-1.68-5.48-2.57-6.64-5.84-2.26-6.41-3.06-13.41-12.15-11,0,0-5.1,7.31-13.64,6.2a14.39,14.39,0,0,0-3.11,9.32c.08,2.65,3.93,9.88,12.12,15.18,7.41,4.8,5.33,8,13.26,12.19C153.5,181.15,161.75,169.68,156.12,158.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,94.17c.53-.17,1.07-1.78,3-3.33s4.44-1.86,5.19-.78,0,.83-1.64,2.64-2.33,4-4.81,6.34",
    style: {
      fill: "#ffa8a7"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrad);
export default __webpack_public_path__ + "static/media/grad.c38fcff0cd0e1caf8b498ea7144e9dd8.svg";
export { ForwardRef as ReactComponent };